import { createContext, useContext } from 'react'

/**
 * What a split view sidebar tells the sheet inside it about the page's toolbar.
 * The sidebar last clicked owns the toolbar row: its sheet puts its own toolbar
 * into `toolbarSlot` while `active`, so every button acts on that sheet's cells.
 */
export interface SplitPane {
  toolbarSlot: HTMLElement | null
  active: boolean
}

export const SplitPaneContext = createContext<SplitPane | null>(null)

export function useSplitPane(): SplitPane | null {
  return useContext(SplitPaneContext)
}
